import React, { useEffect, useRef, useState } from 'react';
import Button from '../../components/Button/Button';
import { AiOutlineLoading } from "react-icons/ai";
import { thaiCourseList, chinaCourseList, malaysiaCourseList, taiwanCourseList, chinaOnlineCourseList } from '../../utils/constant';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { errorToast } from '../../utils/errorHandling';
import { getExperienceById, updateExperienceById } from '../../services/experience';
import { Divider, Select, Space } from 'antd';

const base_url = process.env.REACT_APP_BASE_URL;

const ViewExperience = () => {
    const { t } = useTranslation();
    const [originalData, setOriginalData] = useState({});
    const [formData, setFormData] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const openDropdownsRef = useRef(0); // Track the number of open dropdowns
    // const [isEditing, setIsEditing] = useState(false);
    const [thaiCourse, setThaiCourse] = useState([]);
    const [malaysiaCourse, setMalaysiaCourse] = useState([]);
    const [taiwanCourse, setTaiwanCourse] = useState([]);
    const [chinaCourse, setChinaCourse] = useState([]);
    const [onlineCourse, setOnlineCourse] = useState([]);
    const isOnlineStudent = localStorage.getItem("isOnlineStudent") === 'true';

    const fetchExperience = async () => {
        try {
            const data = await getExperienceById();
            if (data) {
                setFormData(JSON.parse(data.exp_data));
                setOriginalData(JSON.parse(data.exp_data));
            }
        } catch (error) {
            errorToast(error, t("general.formNotFound"), t);
        } finally {
            setIsLoading(false);
        }
    };
    const setSelectionToInitialState = () => {
        setThaiCourse(getSelectedCourses(originalData.thai_course));
        setMalaysiaCourse(getSelectedCourses(originalData.malaysia_course));
        setTaiwanCourse(getSelectedCourses(originalData.taiwan_course));
        setChinaCourse(getSelectedCourses(originalData.china_course));
        setOnlineCourse(getSelectedCourses(originalData.online));
    }
    useEffect(() => {
        setSelectionToInitialState();
    }, [originalData])

    useEffect(() => {
        if (isDropdownOpen) {
            document.body.style.overflow = 'hidden'; // Disable body scroll
        } else {
            document.body.style.overflow = 'auto';  // Re-enable body scroll
        }
    }, [isDropdownOpen]);

    const handleDropdownVisibleChange = (open) => {
        // Update the ref count
        if (open) {
            openDropdownsRef.current += 1; // Increment when a dropdown opens
        } else {
            openDropdownsRef.current -= 1; // Decrement when a dropdown closes
        }

        // Update the state based on the ref count
        setIsDropdownOpen(openDropdownsRef.current > 0);
    };

    const getSelectedCourses = (courseData) => {
        return Object.keys(courseData ?? {}).filter(key => courseData[key] === "1");
    };

    useEffect(() => {
        fetchExperience();
    }, []);

    const handleThaiCourseChange = (value) => {
        setFormData((prevState) => ({
            ...prevState,
            thai_course: {
                ...prevState.thai_course,
                // Set selected courses to "1", others remain unchanged
                ...Object.fromEntries(
                    Object.keys(prevState.thai_course).map((key) => [
                        key,
                        value.includes(key) ? "1" : "0",
                    ])
                ),
            },
        }));
    };
    const handleMalaysiaCourseChange = (value) => {
        setFormData((prevState) => ({
            ...prevState,
            malaysia_course: {
                ...prevState.malaysia_course,
                // Set selected courses to "1", others remain unchanged
                ...Object.fromEntries(
                    Object.keys(prevState.malaysia_course).map((key) => [
                        key,
                        value.includes(key) ? "1" : "0",
                    ])
                ),
            },
        }));
    };
    const handleOnlineCourseChange = (value) => {
        setFormData((prevState) => ({
            ...prevState,
            online: {
                ...prevState.online,
                // Set selected courses to "1", others remain unchanged
                ...Object.fromEntries(
                    Object.keys(prevState.online).map((key) => [
                        key,
                        value.includes(key) ? "1" : "0",
                    ])
                ),
            },
        }));
    };
    const handleTaiwanCourseChange = (value) => {
        setFormData((prevState) => ({
            ...prevState,
            taiwan_course: {
                ...prevState.taiwan_course,
                // Set selected courses to "1", others remain unchanged
                ...Object.fromEntries(
                    Object.keys(prevState.taiwan_course).map((key) => [
                        key,
                        value.includes(key) ? "1" : "0",
                    ])
                ),
            },
        }));
    };
    const handleChinaCourseChange = (value) => {
        setFormData((prevState) => ({
            ...prevState,
            china_course: {
                ...prevState.china_course,
                // Set selected courses to "1", others remain unchanged
                ...Object.fromEntries(
                    Object.keys(prevState.china_course).map((key) => [
                        key,
                        value.includes(key) ? "1" : "0",
                    ])
                ),
            },
        }));
    };

    // const handleCancel = () => {
    //     setFormData(originalData);
    //     setIsEditing(false);
    //     setThaiCourse([]);
    //     setMalaysiaCourse([]);
    //     setTaiwanCourse([]);
    //     setChinaCourse([]);
    //     setOnlineCourse([]);
    //     setSelectionToInitialState();
    // };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
            const response = await updateExperienceById({ exp_data: formData });
            if (response) {
                toast.success(t("Experience.submitSuccess"));
                fetchExperience();
            }
        } catch (error) {
            errorToast(error, t("general.failSubmit"), t);
        } finally {
            setIsSubmitting(false);
        }

    };

    return (
        <>
            {formData === "" ?
                <div className='info-container'>
                    <h3>{t("Experience.retreat_experience")}</h3>
                    <p>{t("general.Des3rd")}</p>
                    {isLoading ?
                        <>
                            <AiOutlineLoading className='spin' />
                            <p>{t("Experience.loading")}</p>
                        </>
                        :
                        <>
                            <p style={{ "color": "#ff0000" }}><br />{t("Experience.submitInstruction")}</p>
                            <div className='action-buttons'>
                                <Link to={isOnlineStudent ? `${base_url}/online_retreat_experience` : `${base_url}/retreat_experience`}>
                                    <Button
                                        buttonStyle='btn--primary'
                                        buttonSize='btn--small'
                                    >{t("Experience.submitButton")}</Button>
                                </Link>

                            </div>
                        </>
                    }
                </div>
                :
                <>
                    <div className='info-container'>
                        <h3>{t("Experience.retreat_experience")}</h3>
                        <p className='mb-0'>{t("general.Des3rd")}</p>
                        {/* {!isEditing ?
                            <div className='action-buttons'>
                                <Button
                                    buttonStyle='btn--primary'
                                    buttonSize='btn--small'
                                    onClick={() => setIsEditing(true)}
                                >{t("general.BTNedit")}</Button>
                            </div>
                            :
                            <div className='action-buttons'>
                                <Button buttonStyle='btn--primary' disabled={isSubmitting} onClick={handleCancel} type="button">{t("general.BTNcancel")}</Button>
                            </div>
                        } */}
                    </div>
                    <div className='form-wrapper'>
                        <form onSubmit={handleSubmit}>
                            <h5 className='mt-3'>{t("Experience.instruction")}</h5>
                            <div className="form-item">
                                <label>{t("Experience.thai_course")}</label>
                                <Select
                                    key={thaiCourse.join(",")}
                                    mode="multiple"
                                    style={{
                                        width: '100%',
                                    }}
                                    size='large'
                                    showSearch={false}
                                    onDropdownVisibleChange={handleDropdownVisibleChange}
                                    placeholder={t("Experience.instruction")}
                                    onChange={handleThaiCourseChange}
                                    options={thaiCourseList(t)}
                                    defaultValue={thaiCourse}
                                    optionRender={(option) => (
                                        <Space direction='vertical'>
                                            <span style={{ color: "#e67300" }}>
                                                {option.data.label}
                                            </span>
                                            <span style={{ color: "#575655" }}>
                                                {option.data.date}
                                            </span>
                                            <Divider style={{ margin: '4px 0', color: '#000000' }} />
                                        </Space>
                                    )}
                                />
                            </div>
                            <div className="form-item">
                                <label>{t("Experience.malaysia_course")}</label>
                                <Select
                                    key={malaysiaCourse.join(",")}
                                    mode="multiple"
                                    style={{
                                        width: '100%',
                                    }}
                                    size='large'
                                    showSearch={false}
                                    onDropdownVisibleChange={handleDropdownVisibleChange}
                                    placeholder={t("Experience.instruction")}
                                    onChange={handleMalaysiaCourseChange}
                                    defaultValue={malaysiaCourse}
                                    options={malaysiaCourseList(t)}
                                    optionRender={(option) => (
                                        <Space direction='vertical'>
                                            <span style={{ color: "#e67300" }}>
                                                {option.data.label}
                                            </span>
                                            <span style={{ color: "#575655" }}>
                                                {option.data.date}
                                            </span>
                                            <Divider style={{ margin: '4px 0', color: '#000000' }} />
                                        </Space>
                                    )}
                                />
                            </div>
                            <div className="form-item">
                                <label>{t("Experience.china_course")}</label>
                                <Select
                                    key={chinaCourse.join(",")}
                                    mode="multiple"
                                    style={{
                                        width: '100%',
                                    }}
                                    size='large'
                                    showSearch={false}
                                    onDropdownVisibleChange={handleDropdownVisibleChange}
                                    placeholder={t("Experience.instruction")}
                                    onChange={handleChinaCourseChange}
                                    defaultValue={chinaCourse}
                                    options={chinaCourseList(t)}
                                    optionRender={(option) => (
                                        <Space direction='vertical'>
                                            <span style={{ color: "#e67300" }}>
                                                {option.data.label}
                                            </span>
                                            <span style={{ color: "#575655" }}>
                                                {option.data.date}
                                            </span>
                                            <Divider style={{ margin: '4px 0', color: '#000000' }} />
                                        </Space>
                                    )}
                                />
                            </div>
                            <div className="form-item">
                                <label>{t("Experience.taiwan_course")}</label>
                                <Select
                                    key={taiwanCourse.join(",")}
                                    mode="multiple"
                                    style={{
                                        width: '100%',
                                    }}
                                    size='large'
                                    showSearch={false}
                                    onDropdownVisibleChange={handleDropdownVisibleChange}
                                    placeholder={t("Experience.instruction")}
                                    onChange={handleTaiwanCourseChange}
                                    defaultValue={taiwanCourse}
                                    options={taiwanCourseList(t)}
                                    optionRender={(option) => (
                                        <Space direction='vertical'>
                                            <span style={{ color: "#e67300" }}>
                                                {option.data.label}
                                            </span>
                                            <span style={{ color: "#575655" }}>
                                                {option.data.date}
                                            </span>
                                            <Divider style={{ margin: '4px 0', color: '#000000' }} />
                                        </Space>
                                    )}
                                />
                            </div>
                            <div className="form-item">
                                <label>{t("Experience.china_online_course")}</label>
                                <Select
                                    key={onlineCourse.join(",")}
                                    mode="multiple"
                                    style={{
                                        width: '100%',
                                    }}
                                    size='large'
                                    showSearch={false}
                                    onDropdownVisibleChange={handleDropdownVisibleChange}
                                    placeholder={t("Experience.instruction")}
                                    onChange={handleOnlineCourseChange}
                                    defaultValue={onlineCourse}
                                    options={chinaOnlineCourseList(t)}
                                    optionRender={(option) => (
                                        <Space direction='vertical'>
                                            <span style={{ color: "#e67300" }}>
                                                {option.data.label}
                                            </span>
                                            <span style={{ color: "#575655" }}>
                                                {option.data.date}
                                            </span>
                                            <Divider style={{ margin: '4px 0', color: '#000000' }} />
                                        </Space>
                                    )}
                                />
                            </div>
                            <div className='submit-button d-flex justify-content-center mt-4 gap-3'>
                                <Button buttonStyle='btn--primary' disabled={isSubmitting} type="submit">
                                    {isSubmitting ? <AiOutlineLoading className="spin" /> : t("general.BTNsave")}
                                </Button>
                            </div>
                        </form>
                    </div>
                </>
            }

        </>
    )
}

export default ViewExperience